import { Cue, sound } from './sound';

const BUZZ: Partial<Record<Cue, number | number[]>> = {
    ui: 8,
    flip: 18,
    burst: [60, 30, 120, 40, 200],
    reveal: [20, 40, 20, 40, 50],
};

/** One cue = a sound plus a short haptic buzz where the device has one. */
export const playCue = (cue: Cue): void => {
    sound.play(cue);
    buzz(BUZZ[cue]);
};

/** A vibration pattern, unless the person muted the app or the device cannot vibrate. */
export const buzz = (pattern?: number | number[]): void => {
    if (
        pattern !== undefined &&
        !sound.muted &&
        typeof navigator.vibrate === 'function'
    ) {
        try {
            navigator.vibrate(pattern);
        } catch {
            // Not allowed before a tap; harmless.
        }
    }
};
